import { render, staticRenderFns } from "./Xg.vue?vue&type=template&id=7ebd3cb9&scoped=true&"
import script from "./Xg.vue?vue&type=script&lang=js&"
export * from "./Xg.vue?vue&type=script&lang=js&"
import style0 from "./Xg.vue?vue&type=style&index=0&id=7ebd3cb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebd3cb9",
  null
  
)

export default component.exports